import { Flex, FormLabel } from "@chakra-ui/react";
import { SelectControl } from "formik-chakra-ui";
import _ from "lodash";
import React, { useMemo } from "react";
import { FormikSwitchableContent } from "src/components/Inputs/FormikSwitchableContent";
import useCheckUserRole from "src/hooks/useCheckUserRole";

const PermissionLevels = [
  { label: "District Admin", value: "district-admin" },
  { label: "Org Admin", value: "org-admin" },
  { label: "School Admin", value: "school-admin" },
];
type Props = { name: string };
export const PermissionLevel: React.FC<Props> = ({ name }) => {
  const { isAvelaAdmin, isOrgAdmin, isDistrictAdmin, isSchoolAdmin } =
    useCheckUserRole();
  const permissions = useMemo(() => {
    if (isAvelaAdmin) {
      return PermissionLevels;
    }
    if (isOrgAdmin) {
      return PermissionLevels.filter((level) => level.value !== "admin");
    }
    if (isDistrictAdmin) {
      return PermissionLevels.filter((level) =>
        ["district-admin", "school-admin"].includes(level.value)
      );
    }
    if (isSchoolAdmin) {
      return PermissionLevels.filter((level) => level.value === "school-admin");
    }
    return [];
  }, [isAvelaAdmin, isDistrictAdmin, isOrgAdmin, isSchoolAdmin]);

  return (
    <FormikSwitchableContent
      label="Internal-only"
      name="permissionLevelSwitch"
      checked={[true, ""]}
      unchecked={[false, ""]}
      showContent={_.identity}
      description="When enabled, it will not be displayed to parents."
    >
      <Flex gap="0.5" paddingTop="2" direction="column">
        <FormLabel htmlFor={name}>Permission level</FormLabel>
        <SelectControl
          selectProps={{ placeholder: "Select a permission level" }}
          name={name}
        >
          {permissions.map((option) => {
            return (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            );
          })}
        </SelectControl>
      </Flex>
    </FormikSwitchableContent>
  );
};
